<div class="sentiment-theme-distribution">
  <div class="sentiment-theme-distribution__header">
    <div class="sentiment-theme-distribution__title">{{ listTitle }}</div>
    <div class="sentiment-theme-distribution__filters">
      <select
        class="sentiment-theme-distribution__select"
        [ngModel]="sentimentFilter"
        (ngModelChange)="onSentimentChange($event)"
      >
        <option *ngFor="let opt of sentimentOptions" [value]="opt.value">{{ opt.label }}</option>
      </select>
      <select
        class="sentiment-theme-distribution__select"
        [ngModel]="viewMode"
        (ngModelChange)="onViewModeChange($event)"
      >
        <option *ngFor="let opt of viewOptions" [value]="opt.value">{{ opt.label }}</option>
      </select>
    </div>
  </div>

  <!-- Themes view: main themes, then collapsible Others (suggested themes inside) -->
  <div
    class="sentiment-theme-distribution__list"
    *ngIf="viewMode === 'themes' && (themeMainRows.length || themeOthersSection); else themesEmpty"
  >
    <div *ngFor="let item of themeMainRows" class="sentiment-theme-distribution__row">
      <span class="sentiment-theme-distribution__name" [title]="item.name">{{ item.name }}</span>
      <div class="sentiment-theme-distribution__bar-wrap">
        <div
          class="sentiment-theme-distribution__bar"
          [style.width.%]="(item.count / maxCount) * 100"
        ></div>
      </div>
      <span class="sentiment-theme-distribution__count">{{ item.count | number }}</span>
    </div>
    <div *ngIf="themeOthersSection" class="sentiment-theme-distribution__others-block">
      <button
        type="button"
        class="sentiment-theme-distribution__group-header sentiment-theme-distribution__group-header--others"
        (click)="toggleOthersSection(themesOthersSectionId)"
      >
        <span
          class="sentiment-theme-distribution__group-chevron"
          [class.sentiment-theme-distribution__group-chevron--open]="isOthersSectionExpanded(themesOthersSectionId)"
          >▼</span>
        <span class="sentiment-theme-distribution__group-name">Others</span>
        <span class="sentiment-theme-distribution__group-total">{{ themeOthersSection.total | number }}</span>
      </button>
      <div
        class="sentiment-theme-distribution__group-body sentiment-theme-distribution__group-body--others"
        *ngIf="isOthersSectionExpanded(themesOthersSectionId)"
      >
        <div
          *ngFor="let item of themeOthersSection.rows"
          class="sentiment-theme-distribution__row sentiment-theme-distribution__row--nested"
        >
          <span class="sentiment-theme-distribution__name" [title]="item.name">{{ item.name }}</span>
          <div class="sentiment-theme-distribution__bar-wrap">
            <div
              class="sentiment-theme-distribution__bar sentiment-theme-distribution__bar--others"
              [style.width.%]="(item.count / maxCount) * 100"
            ></div>
          </div>
          <span class="sentiment-theme-distribution__count">{{ item.count | number }}</span>
        </div>
      </div>
    </div>
  </div>
  <ng-template #themesEmpty>
    <div class="sentiment-theme-distribution__empty" *ngIf="viewMode === 'themes'">No theme data</div>
  </ng-template>

  <!-- Sub-themes: non–suggested themes above (body + inline Others for suggested subs); bottom Others = suggested themes -->
  <div class="sentiment-theme-distribution__list sentiment-theme-distribution__list--grouped" *ngIf="viewMode === 'subthemes' && (groupedSubThemes.length || subthemeOthersSection); else subthemesEmpty">
    <div *ngFor="let group of groupedSubThemes" class="sentiment-theme-distribution__group">
      <button
        type="button"
        class="sentiment-theme-distribution__group-header"
        (click)="toggleThemeCollapsed(group.themeId)"
        [title]="'View complete: ' + group.themeName"
      >
        <span class="sentiment-theme-distribution__group-chevron" [class.sentiment-theme-distribution__group-chevron--open]="!isThemeCollapsed(group.themeId)">▼</span>
        <span class="sentiment-theme-distribution__group-name" [title]="group.themeName">{{ group.themeName }}</span>
        <span class="sentiment-theme-distribution__group-total">{{ group.total | number }}</span>
      </button>
      <div class="sentiment-theme-distribution__group-body" *ngIf="!isThemeCollapsed(group.themeId)">
        <div
          *ngFor="let sub of group.subThemes"
          class="sentiment-theme-distribution__row sentiment-theme-distribution__row--nested"
        >
          <span class="sentiment-theme-distribution__name" [title]="sub.subThemeName">{{ sub.subThemeName }}</span>
          <div class="sentiment-theme-distribution__bar-wrap">
            <div
              class="sentiment-theme-distribution__bar"
              [style.width.%]="(sub.count / maxSubThemeCount) * 100"
            ></div>
          </div>
          <span class="sentiment-theme-distribution__count">{{ sub.count | number }}</span>
        </div>
        <div
          *ngIf="group.othersInTheme"
          class="sentiment-theme-distribution__others-block sentiment-theme-distribution__others-block--inline-theme"
        >
          <button
            type="button"
            class="sentiment-theme-distribution__group-header sentiment-theme-distribution__group-header--others sentiment-theme-distribution__group-header--others-inline"
            [attr.aria-expanded]="isOthersSectionExpanded(subthemeInlineOthersSectionId(group.themeId))"
            (click)="toggleOthersSection(subthemeInlineOthersSectionId(group.themeId))"
          >
            <span
              class="sentiment-theme-distribution__group-chevron"
              [class.sentiment-theme-distribution__group-chevron--open]="
                isOthersSectionExpanded(subthemeInlineOthersSectionId(group.themeId))
              "
              >▼</span>
            <span class="sentiment-theme-distribution__group-name-row">
              <span
                class="sentiment-theme-distribution__group-name sentiment-theme-distribution__group-name--with-chip"
                title="AI-proposed sub-themes; not from your taxonomy"
                >Others - Suggested Sub theme</span>
              <span
                class="sentiment-theme-distribution__suggestion-chip"
                title="These labels are suggestions from the model, not fixed taxonomy entries"
                >Suggestion</span>
            </span>
            <span class="sentiment-theme-distribution__group-total">{{ group.othersInTheme.total | number }}</span>
          </button>
          <div
            class="sentiment-theme-distribution__group-body sentiment-theme-distribution__group-body--others sentiment-theme-distribution__group-body--others-inline"
            *ngIf="isOthersSectionExpanded(subthemeInlineOthersSectionId(group.themeId))"
          >
            <div
              *ngFor="let sub of group.othersInTheme.rows; trackBy: trackBySubThemeRowKey"
              class="sentiment-theme-distribution__row sentiment-theme-distribution__row--nested"
            >
              <span class="sentiment-theme-distribution__name" [title]="sub.subThemeName">{{ sub.subThemeName }}</span>
              <div class="sentiment-theme-distribution__bar-wrap">
                <div
                  class="sentiment-theme-distribution__bar"
                  [style.width.%]="(sub.count / maxSubThemeCount) * 100"
                ></div>
              </div>
              <span class="sentiment-theme-distribution__count">{{ sub.count | number }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="subthemeOthersSection" class="sentiment-theme-distribution__others-block sentiment-theme-distribution__others-block--subthemes-global">
      <button
        type="button"
        class="sentiment-theme-distribution__group-header sentiment-theme-distribution__group-header--others"
        [attr.aria-expanded]="isOthersSectionExpanded(subthemesOthersSectionId)"
        (click)="toggleOthersSection(subthemesOthersSectionId)"
      >
        <span
          class="sentiment-theme-distribution__group-chevron"
          [class.sentiment-theme-distribution__group-chevron--open]="isOthersSectionExpanded(subthemesOthersSectionId)"
          >▼</span>
        <span class="sentiment-theme-distribution__group-name-row">
          <span
            class="sentiment-theme-distribution__group-name sentiment-theme-distribution__group-name--with-chip"
            title="AI-proposed themes; expand to browse by theme"
            >Others - Suggested theme</span>
          <span
            class="sentiment-theme-distribution__suggestion-chip"
            title="These themes are suggestions from the model, not from your uploaded taxonomy"
            >Suggestion</span>
        </span>
        <span class="sentiment-theme-distribution__group-total">{{ subthemeOthersSection.total | number }}</span>
      </button>
      <div
        class="sentiment-theme-distribution__group-body sentiment-theme-distribution__group-body--others sentiment-theme-distribution__group-body--others-subthemes-nested"
        *ngIf="isOthersSectionExpanded(subthemesOthersSectionId)"
      >
        <div
          *ngFor="let og of subthemeOthersSection.themeGroups; trackBy: trackByThemeGroupId"
          class="sentiment-theme-distribution__group sentiment-theme-distribution__group--in-others"
        >
          <button
            type="button"
            class="sentiment-theme-distribution__group-header"
            [attr.aria-expanded]="!isSubthemeOthersInnerCollapsed(og.themeId)"
            (click)="toggleSubthemeOthersInnerCollapsed(og.themeId)"
            [title]="'View complete: ' + og.themeName"
          >
            <span
              class="sentiment-theme-distribution__group-chevron"
              [class.sentiment-theme-distribution__group-chevron--open]="!isSubthemeOthersInnerCollapsed(og.themeId)"
              >▼</span>
            <span class="sentiment-theme-distribution__group-name-row">
              <span class="sentiment-theme-distribution__group-name" [title]="og.themeName">{{ og.themeName }}</span>
              <span
                class="sentiment-theme-distribution__suggestion-chip sentiment-theme-distribution__suggestion-chip--compact"
                title="This theme was proposed by the model (suggested theme)"
                >Suggested</span>
            </span>
            <span class="sentiment-theme-distribution__group-total">{{ og.total | number }}</span>
          </button>
          <div class="sentiment-theme-distribution__group-body" *ngIf="!isSubthemeOthersInnerCollapsed(og.themeId)">
            <div
              *ngFor="let sub of og.subThemes; trackBy: trackBySubThemeRowKey"
              class="sentiment-theme-distribution__row sentiment-theme-distribution__row--nested"
            >
              <span class="sentiment-theme-distribution__name" [title]="sub.subThemeName">{{ sub.subThemeName }}</span>
              <div class="sentiment-theme-distribution__bar-wrap">
                <div
                  class="sentiment-theme-distribution__bar"
                  [style.width.%]="(sub.count / maxSubThemeCount) * 100"
                ></div>
              </div>
              <span class="sentiment-theme-distribution__count">{{ sub.count | number }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <ng-template #subthemesEmpty>
    <div class="sentiment-theme-distribution__empty" *ngIf="viewMode === 'subthemes'">No sub-theme data</div>
  </ng-template>
</div>
